import throttle from "lodash.throttle";

class Navigation {
    constructor() {
        this.nav = document.querySelector('.site-header');

        if (this.nav !== null) {
            this.topOfNav = this.nav.offsetTop;
            window.addEventListener("scroll", throttle(this.fixNav.bind(this), 10));
        }

        this.openMobileMenu();
    }

    fixNav() {
        if (window.scrollY >= 120) {
            document.body.classList.add('fixed-nav');
        } else {
            document.body.classList.remove('fixed-nav');
        }
    }

    openMobileMenu() {
        const openMobileButton = document.getElementById('toggleNav');
        const mobileMenu = document.getElementById('mobile-menu');

        const openSubmenu = document.querySelectorAll('.open-submenu')

        openMobileButton.addEventListener('click', () => {
            document.body.classList.toggle('mobile-opened');
            document.body.classList.toggle('overflow-hidden');
            mobileMenu.classList.toggle('hidden');
        });


        openSubmenu.forEach(item => {
            item.addEventListener('click', e => {
                item.nextElementSibling.classList.toggle('hidden');
                const icon = item.querySelector('svg');
                icon.classList.toggle('transform');
                icon.classList.toggle('rotate-180');
            })
        });

    }


}

export default Navigation;